import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { FileUpload } from '../model/file-upload';
import { FirebaseService } from '../services/firebase.service';
import { UploadFileService } from '../services/upload-file.service';

@Component({
  selector: 'app-dash-employee',
  templateUrl: './dash-employee.component.html',
  styleUrls: ['./dash-employee.component.css']
})
export class DashEmployeeComponent implements OnInit {
  userid!:string;
  profileurl!:string;
  obj : any;
  data_target: any;
  username!:string;
  card_details_appraval_req_main : any[] = [];
  card_array_size:any;
  employee_details_main : any[] = [];
  appcurrentuser : any;
  constructor(private router: Router, public firebaseService: FirebaseService,private firestore: AngularFirestore,private uploadService: UploadFileService) {
    this.obj = JSON.parse(localStorage.getItem('user')|| '{}');
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
  };
    console.log(this.obj.email);
    this.firestore.collection("users").ref.where("username", "==", this.obj.email).onSnapshot(snap =>{
      snap.forEach(userRef => {
        if(userRef.data()["role"] !== "employee"){

          var elements= document.getElementById('employee');
          elements.className = " display_none";
        }else{
    this.firestore.collection("users").ref.doc(this.obj.email)
    .get()
    .then((querySnapshot) => {
            this.profileurl = querySnapshot.data()['profileurl'];
            this.username = querySnapshot.data()["name"];
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });
     // card requested details
     this.firestore.collection("users").ref.where("approval_status", "==", "Requested").get()
     .then((querySnapshot) => {
       this.card_array_size = querySnapshot.size;
       querySnapshot.forEach((doc) => {
         this.card_details_appraval_req_main.push([doc.data()["name"],
         doc.data()["username"],
         doc.data()["phoneno"],
         doc.data()["reference_code"],
         doc.data()["package"],
         doc.data()["createddate"].toDate(),
         doc.data()["enddate"].toDate(),
         doc.data()["approval_status"]]);
        });
     })
     .catch((error) => {
         console.log("Error getting documents: ", error);
     });

   }
  })
})
  }

  ngOnInit(): void {
  }


  // card approval rejection
  get_card_approved(id:string){
    let req_id : any;
    console.log("app"+req_id);
  let update_details={
    approval_status: "Approved",
    approved_by: this.obj.email,
  }
  this.firestore.collection("users").doc(id).update(update_details)
  .then(user => {

    window.alert("Approved...");
  })
  .catch((error) => {
      console.log("Error getting documents: ", error);
  });

  }
  // get_card_rejected(id:string){
  //   let req_id : any;
  // let update_details={
  //   approval_status: "Rejected",
  // }
  // this.firestore.collection("users").doc(id).update(update_details)
  // .then(user => {

  //   window.alert("Rejected...");
  // })
  // .catch((error) => {
  //     console.log("Error getting documents: ", error);
  // });

  // }
  mob_click(){
    var elements= document.getElementById('employee');
    elements.className = " mobile-nav-active2";
    let btn = document.getElementById("mobi");
    if(btn.className === "bi bi-x mobile-nav-toggle2 d-xl-none"){
    btn.className = "bi bi-list mobile-nav-toggle2 d-xl-none";
    elements.className = "";
    }else{
    btn.className = "bi bi-x mobile-nav-toggle2 d-xl-none";
    }
  }
  selectedEmpProfFiles: FileList;
  currentFileEmpProfUpload: FileUpload;
  percentageEmpProf: number;


selectEmpProfFile(event) {
  this.selectedEmpProfFiles = event.target.files;
}

upload() {
  const file = this.selectedEmpProfFiles.item(0);
  this.selectedEmpProfFiles = undefined;
  this.currentFileEmpProfUpload = new FileUpload(file);
  this.uploadService.pushEmployeeProfilePicFileToStorage(this.currentFileEmpProfUpload).subscribe(
    percentage => {
      this.percentageEmpProf = Math.round(percentage);
    },
    error => {
      console.log(error);
    }
  );
}

loggedout(){
  this.firebaseService.logOut();
}
}
